import React from 'react';

const IconSelectorTool = () => (
    <svg width="20px" height="20px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path
                d="M7 0h36v34.617c0 5.349-.557 7.289-1.603 9.244a10.904 10.904 0 0 1-4.536 4.536C34.906 49.443 32.966 50 27.617 50H7V0z"
                fill="#42B4E6"
            />
            <path
                d="M31.59 38.598a3.824 3.824 0 0 1-2.53-1.48l-4.946-6.495a3.843 3.843 0 0 1-.373-.625 9.356 9.356 0 0 1-9.554-3.44A9.162 9.162 0 0 1 16 13.656a9.283 9.283 0 0 1 6.887-1.759 9.302 9.302 0 0 1 6.137 3.589 9.111 9.111 0 0 1 1.79 6.83 9.175 9.175 0 0 1-1.086 3.21c.2.177.376.363.503.53l4.946 6.499a3.776 3.776 0 0 1-.747 5.318 3.83 3.83 0 0 1-2.84.724zm-.516-2.981c.21.277.515.455.863.504.349.049.691-.038.97-.247a1.29 1.29 0 0 0 .256-1.815l-4.945-6.498c-.102-.134-.418-.393-.433-.427l-.046-.004-.026-.003-.027-.003a1.259 1.259 0 0 1-1.088-1.25c.004-.484.295-.955.536-.96a6.678 6.678 0 0 0 1.179-2.948 6.633 6.633 0 0 0-1.303-4.976 6.772 6.772 0 0 0-4.468-2.614 6.76 6.76 0 0 0-5.02 1.28 6.676 6.676 0 0 0-1.32 9.399c1.745 2.295 4.763 3.243 7.473 2.369l.015-.007.062-.026c.401-.363 1-.43 1.477-.157.46.263.706.783.616 1.224.03.173.176.52.284.663l4.945 6.496z"
                fill="#FFF"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export default IconSelectorTool;
